module.exports = __webpack_public_path__ + "img/bg2.95d43429.png";